"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowParametersWarning = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const borderRadiusValue = '4px';
const warningStyle = (0, vizportalclient_common_components_1.cssClass)('parametersWarningBanner', {
    display: 'flex',
    padding: widgets_1.TabStyles.Spacing.MediumSpace,
    borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`,
    backgroundColor: '#fef9ef',
    borderLeft: '4px solid #feca63',
    margin: `${widgets_1.TabStyles.Spacing.LargeSpace}px ${widgets_1.TabStyles.Spacing.MediumSpace}px 0 ${widgets_1.TabStyles.Spacing.MediumSpace}px `,
});
const message = (0, vizportalclient_common_components_1.cssClass)('parameterWarningMessage', {
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
});
function FlowParametersWarning() {
    return (react_1.default.createElement("div", { className: warningStyle },
        react_1.default.createElement(catalog_icons_1.SvgWarning, null),
        react_1.default.createElement("div", { className: message }, catalog_messages_1.Messages.FlowParametersLineageWarning())));
}
exports.FlowParametersWarning = FlowParametersWarning;
//# sourceMappingURL=FlowParametersWarning.js.map